import { overquotaAbTariffName } from 'reactApp/appHelpers/featuresHelpers/features/overquotaAbTariff';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const getModalName = () => (overquotaAbTariffName ? `mnz_overquota_31day_${overquotaAbTariffName}` : 'overquota_splash_new');

export const getModalFullBlockedName = () =>
    overquotaAbTariffName ? `mnz_overquota_94day_${overquotaAbTariffName}` : 'overquota_full_blocked';

export const renderOverquotaSplash = (data, onClose?: Parameters<typeof openPopupHelper>[0]['onClose']) =>
    openPopupHelper({ popupName: popupNames.OVERQUOTA_SPLASH, data, onClose });
